import {
  type PopupProps,
  Username as UsernamePopup
} from '@CS/components/Popups';
import API from '@/services/api';

type UsernameProps = PopupProps & {
  bold?: boolean;
};

export const Username = ({ bold, ...props }: UsernameProps) => {
  const onSubmit = async (username: string) => API.updateUser({ username });
  return <UsernamePopup onSubmit={onSubmit} bold={bold} {...props} />;
};
